// Generated by CoffeeScript 1.12.6
  angular.module('app.editEmail', ['pascalprecht.translate', 'angularFileUpload', 'angular.filter', 'ngSlider', 'ngCookies', 'ngAnimate', 'ngSanitize', 'angularSpinner', 'angular-clipboard', 'ui.nested.combobox', 'ngCkeditor']).controller('EditEmailCtrl', [
    '$scope', '$log', '$http', '$modal', 'sharedProperties', 'currentLawyer', '$location', '$cookies', 'usSpinnerService', '$timeout', 'logger', '$window', '$filter', function($scope, $log, $http, $modal, sharedProperties, currentLawyer, $location, $cookies, usSpinnerService, $timeout, logger, $window, $filter) {
      var transformCCRecepients, transformRecepients;
      $log.info("EditEmailCtrl initialized");
      $scope.emailCategory = "";
      $scope.emailBodyChanged = false;
      $scope.editorOptions = {
        extraPlugins: 'colorbutton'
      };

      $scope.logOut = function() {
        sharedProperties.logOut();
      };

      $scope.openTestEmailPopUp = function() {
        var allPlaceholders, data, emailBodyPlaceholderPattern, emailBodyPlaceholders, generalPlaceholderPattern, i, index, ref, subjectPlaceholders;
        usSpinnerService.spin('spinner-1');
        emailBodyPlaceholderPattern = /\&lt;%(.*?)%&gt;/g;
        generalPlaceholderPattern = /\<%(.*?)%>/g;
        emailBodyPlaceholders = $scope.emailCategory.content.match(emailBodyPlaceholderPattern);
        subjectPlaceholders = $scope.emailCategory.subject.match(generalPlaceholderPattern);
        if (subjectPlaceholders !== null) {
          allPlaceholders = emailBodyPlaceholders.concat(subjectPlaceholders);
        } else {
          allPlaceholders = emailBodyPlaceholders;
        }
        if (allPlaceholders) {
          for (index = i = 0, ref = allPlaceholders.length; 0 <= ref ? i < ref : i > ref; index = 0 <= ref ? ++i : --i) {
            allPlaceholders[index] = allPlaceholders[index].replace(/&lt;/g, "<");
            allPlaceholders[index] = allPlaceholders[index].replace(/&gt;/g, ">");
          }
        }
        data = {
          placeholders: allPlaceholders,
          emailCategory: $scope.emailCategory.category_ID
        };
        $http.post('/api/validate-email-body', data).then(function({data, status, headers, config}) {
          var modalInstance;
          usSpinnerService.stop('spinner-1');
          $scope.placeholdersModified = false;
          if (data.samePlaceholders === true) {
            $scope.placeholdersModified = false;
            $scope.emailCategory.recepient = "";
            modalInstance = $modal.open({
              templateUrl: "sendTestEmail.html",
              controller: 'sendTestEmailCtrl',
              resolve: {
                modalData: function() {
                  return $scope.emailCategory;
                }
              }
            });
            return modalInstance.result.then((function(updatedData) {
              $scope.emailBodyChanged = false;
            }), function() {
            });
          } else {
            return $scope.placeholdersModified = true;
          }
        },function ({data}){
          $log.info("error in validating placeholders");
          return $log.info(data);
        });
      };
      $scope.closePopUp = function() {
        $modalInstance.dismiss("close");
      };
      $scope.fetchEmailCategory = function() {
        if (($location.search().emailCategory.category_ID)) {
          $scope.emailCategory = $location.search().emailCategory;
          transformRecepients();
          transformCCRecepients();
          $http.post('/api/admin/save-email-listing-in-session', {
            emailCategory: $scope.emailCategory
          }).then(function({data, status, headers, config}) {},function(data) {
            $log.info("error in saving email info in session");
          });
        } else {
          $http.post('/api/fetch-current-user', {
            'contentType': 'application/json'
          }).then(function({data, status, headers, config}) {
            if (data.emailCategory) {
              $scope.emailCategory = data.emailCategory;
              transformRecepients();
              transformCCRecepients();
              $http.post('/api/admin/save-email-listing-in-session', {
                emailCategory: $scope.emailCategory
              }).then(function({data, status, headers, config}) {},function(data) {
                $log.info("error in saving email info in session");
              });
            } else {

            }
            $log.info("nothing found in session");
          },function(data) {
            if (status === 440) {
              $location.url('/signin');
            }
          });
        }
      };
      transformRecepients = function() {
        var bccRecepients, bccRecepientsSize, i, index, ref;
        bccRecepients = "";
        bccRecepientsSize = $scope.emailCategory.email_bccs.length;
        for (index = i = 0, ref = bccRecepientsSize; 0 <= ref ? i < ref : i > ref; index = 0 <= ref ? ++i : --i) {
          if (index === bccRecepientsSize) {
            bccRecepients = bccRecepients + $scope.emailCategory.email_bccs[index].email_address;
          } else {

          }
          bccRecepients = bccRecepients + ", " + $scope.emailCategory.email_bccs[index].email_address;
        }
        bccRecepients = bccRecepients.slice(1);
        $scope.emailCategory.bcc = bccRecepients.trim();
      };
      transformCCRecepients = function() {
        var ccRecepients, ccRecepientsSize, i, index, ref;
        ccRecepients = "";
        ccRecepientsSize = $scope.emailCategory.email_ccs.length;
        for (index = i = 0, ref = ccRecepientsSize; 0 <= ref ? i < ref : i > ref; index = 0 <= ref ? ++i : --i) {
          if (index === ccRecepientsSize) {
            ccRecepients = ccRecepients + $scope.emailCategory.email_ccs[index].email_address;
          } else {

          }
          ccRecepients = ccRecepients + ", " + $scope.emailCategory.email_ccs[index].email_address;
        }
        ccRecepients = ccRecepients.slice(1);
        $scope.emailCategory.cc = ccRecepients.trim();
      };
      $scope.saveEmailCategory = function() {
        var allPlaceholders, data, emailBodyPlaceholderPattern, emailBodyPlaceholders, generalPlaceholderPattern, i, index, ref, subjectPlaceholders;
        usSpinnerService.spin('spinner-1');
        emailBodyPlaceholderPattern = /\&lt;%(.*?)%&gt;/g;
        generalPlaceholderPattern = /\<%(.*?)%>/g;
        emailBodyPlaceholders = $scope.emailCategory.content.match(emailBodyPlaceholderPattern);
        subjectPlaceholders = $scope.emailCategory.subject.match(generalPlaceholderPattern);
        if (subjectPlaceholders !== null) {
          allPlaceholders = emailBodyPlaceholders.concat(subjectPlaceholders);
        } else {
          allPlaceholders = emailBodyPlaceholders;
        }
        if (allPlaceholders) {
          for (index = i = 0, ref = allPlaceholders.length; 0 <= ref ? i < ref : i > ref; index = 0 <= ref ? ++i : --i) {
            allPlaceholders[index] = allPlaceholders[index].replace(/&lt;/g, "<");
            allPlaceholders[index] = allPlaceholders[index].replace(/&gt;/g, ">");
          }
        }
        data = {
          placeholders: allPlaceholders,
          emailCategory: $scope.emailCategory.category_ID
        };
        $http.post('/api/validate-email-body', data).then(function({data, status, headers, config}) {
          $scope.placeholdersModified = false;
          if (data.samePlaceholders === true) {
            $scope.placeholdersModified = false;
            return $http.post('/api/update-email-category', $scope.emailCategory).then(function(success) {
              return $http.post('/api/admin/navigate-email-listing').then(function({data, status, headers, config}) {
                return $location.url("/admin/email-listing");
              });
            });
          } else {
            usSpinnerService.stop('spinner-1');
            return $scope.placeholdersModified = true;
          }
        },function({data}) {
          $log.info("error in validating placeholders");
          return $log.info(data);
        });
      };
      return $scope.navigateToEmailListing = function() {
        $location.url('/admin/email-listing');
      };
    }
  ]).controller('sendTestEmailCtrl', [
    '$scope', '$http', '$log', '$modalInstance', '$location', 'modalData', function($scope, $http, $log, $modalInstance, $location, modalData) {
      $scope.modalData = modalData;
      $scope.sendEmail = function() {
        $http.post('/api/send-test-email', $scope.modalData).then(function({data, status, headers, config}) {
          return $log.info("Sent Test Email Users");
        },function(data) {
          return $log.info('error');
        });
        $modalInstance.close();
      };
      return $scope.close = function() {
        $modalInstance.dismiss("cancel");
      };
    }
  ]);



// WEBPACK FOOTER //
// ./scripts/edit-email/EditEmailCtrl.js